import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "placeholder:text-foreground focus-visible:border-[#353353] focus-visible:ring-theme/25 aria-invalid:ring-white/5 aria-invalid:border-white/70 dark:bg-input/30 flex field-sizing-content min-h-[120px] w-full rounded-[10px] lg:rounded-[15px] border border-[#353353] bg-transparent px-[20px] py-[20px] lg:px-[25px] lg:py-[17px] text-[16px] lg:text-[18px] shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
